module.exports = __webpack_public_path__ + "static/img/full.1ee0f3a3.svg";